import { render, staticRenderFns } from "./DisciplineDropdown.vue?vue&type=template&id=00fcfc25"
import script from "./DisciplineDropdown.vue?vue&type=script&lang=js"
export * from "./DisciplineDropdown.vue?vue&type=script&lang=js"
import style0 from "./DisciplineDropdown.vue?vue&type=style&index=0&id=00fcfc25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports